export default __webpack_public_path__ + "static/media/1062.fe7847c4.png";